import React, { Component, Fragment } from 'react';
import { withApollo } from 'react-apollo';
import * as Queries from '../../graphQL/queries/shipmentQueries';
import ErrorNotification from '../../components/common/ErrorNotification';
import LoadingIndicator from '../../components/LoadingIndicator';
import { AppContext } from '../../AppProvider';

import HandlingUnit from './HandlingUnit';

class Labels extends Component {
  state = { shipment: {}, loading: true };

  async componentDidMount() {
    const {
      match: {
        params: { id }
      },
      client,
      t
    } = this.props;

    if (!id) {
      this.setState({ loading: false, error: t('No shipment information!') });
      return;
    }

    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(false);
    setSidebarVisible(false);

    // Determine which query we are calling based on the type of 'id'
    if (isNaN(id)) {
      const {
        data: {
          unauthenticated: { shipment }
        }
      } = await client.query({
        query: Queries.unauthenticatedShipmentById,
        variables: { id }
      });

      this.setState({
        shipment,
        loading: false
      });
    } else {
      const {
        data: {
          shipment: { shipmentForBol: shipment }
        }
      } = await client.query({
        query: Queries.shipmentByIdForBol,
        variables: { id }
      });

      this.setState({
        shipment,
        loading: false
      });
    }

    // need a slight delay here before we print to make sure
    // everything gets fully loaded
    setTimeout(() => {
      window.print();
      window.close();
    }, 500);
  }

  // componentDidUpdate() {
  //   // wait for it... The Beacon icon will pop up eventually.  We want to hide it for the print.
  //   if (document.getElementById('HSBeaconFabButton')) {
  //     document.getElementById('HSBeaconFabButton').hidden = true;
  //   }
  // }

  componentWillUnmount() {
    const { setSearchbarVisible, setSidebarVisible } = this.context;
    setSearchbarVisible(true);
    setSidebarVisible(true);
    document.getElementById('HSBeaconFabButton').hidden = false;
  }

  render() {
    const { shipment, loading, error } = this.state;

    if (loading) {
      return <LoadingIndicator />;
    }

    if (error) {
      return <ErrorNotification message={error} />;
    }

    const handlingUnits = shipment.handlingUnits;

    return (
      <Fragment>
        {handlingUnits.map((unit, index) => {
          return (
            <HandlingUnit
              key={index}
              shipment={shipment}
              unit={unit}
              index={index}
              totUnits={handlingUnits.length}
            />
          );
        })}
      </Fragment>
    );
  }
}

Labels.contextType = AppContext;
export default withApollo(Labels);
